import { render, staticRenderFns } from "./AddContentTable.vue?vue&type=template&id=73eb64f4"
import script from "./AddContentTable.vue?vue&type=script&lang=js"
export * from "./AddContentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports